// extracted by mini-css-extract-plugin
export default {"scroll_decoration":"property-request_scroll_decoration__wb55u"};